import React from "react";
import { EventInventoryRecord } from "@src/store/pricing/queryEventInventoryAllSlice";
import { useAppSelector } from "@src/store/hooks";
import { X, Lock } from "lucide-react";
import styles from "./BulkEditSectionRow.module.scss";
import helperStyles from "@src/components/helpers.module.scss";
import { clx } from "../utils/stringUtils";

type TBulkEditSectionRowItem = {
	data: EventInventoryRecord;
	targetSection: string | null;
	targetRow: string | null;
	onRemove?: (listingId: number) => void;
};

const BulkEditSectionRowItem = ({ data, targetSection, targetRow, onRemove }: TBulkEditSectionRowItem) => {
	const selectionEvent = useAppSelector((state) => state.pricing.selection.event);

	const itemAny = data as EventInventoryRecord & { Event_Headliner?: string; Event_Name?: string };
	const eventName = itemAny.Event_Headliner ?? itemAny.Event_Name ?? selectionEvent?.Event_Headliner ?? "";

	const lockedLevels = [
		data.Section_Locked ? "Section" : null,
		data.Row_Locked ? "Row" : null,
		data.Seat_Locked ? "Seat" : null,
	].filter(Boolean);

	const finalSection = targetSection ?? data.Section;
	const finalRow = targetRow ?? data.Row;

	return (
		<div className={styles.singleListing}>
			<div className={styles.eventCol}>
				<div className={styles.secRowSeatCont}>
					<div style={{ userSelect: "none" }} className={clx(styles.itemTextPrimary, helperStyles.ellipsisDiv)}>
						{eventName}
					</div>
					<div className={styles.itemTextPrimary}>
						{data.Section}, Row {data.Row}
					</div>
					<div style={{ gap: "2px 8px" }} className={clx(styles.textSecondary, helperStyles.flexSmallGap)}>
						<div>ID: {data.Listing_ID}</div>
						{data.Seats ? <div>Seat {data.Seats}</div> : null}
					</div>
					<div className={clx(styles.textSecondary, styles.lockedLine)}>
						<span>Locked: {lockedLevels.length ? lockedLevels.join(", ") : "N/A"}</span>
						{lockedLevels.length ? <Lock size={12} /> : null}
					</div>
				</div>
			</div>
			<div className={styles.valueCol}>
				<div>Sec {data.Section}</div>
				<div>Row {data.Row}</div>
			</div>
			<div className={styles.arrowCol}>→</div>
			<div className={clx(styles.valueCol, styles.targetCol)}>
				<div>Sec {finalSection}</div>
				<div>Row {finalRow}</div>
			</div>
			<div onClick={() => onRemove?.(data.Listing_ID)} className={styles.xContainer}>
				<div>
					<X size={16} />
				</div>
			</div>
		</div>
	);
};

export default BulkEditSectionRowItem;
